import { zod } from "@endya-conformite/ui-kit/src/lya/exports";
import { createGarantieFinanciereIobspSchema2025 } from "./ConformiteGarantieFinanciereIobspSchema2025";

/**
 * Schéma de validation pour la Garantie Financière IOBSP
 * pour les millésimes >= 2026 (nouvelle logique avec hasGarantieFinanciere)
 *
 * Réutilise le schéma 2025 en rendant les champs optionnels,
 * puis applique la validation conditionnelle selon hasGarantieFinanciere
 */
export const createGarantieFinanciereIobspSchema2026 = (millesime: number) => {
  const schema2025 = createGarantieFinanciereIobspSchema2025(millesime);

  return schema2025
    .extend({
      hasGarantieFinanciere: zod.boolean().nullable(),
    })
    .superRefine((data, ctx) => {
      // Si pas de GF (false), pas de validation supplémentaire
      if (data.hasGarantieFinanciere === false) return;

      // Si GF (true), appliquer la validation 2025
      if (data.hasGarantieFinanciere === true) {
        const result = schema2025.safeParse(data);
        if (!result.success) {
          result.error.issues.forEach((issue) => ctx.addIssue(issue));
        }
      }
    });
};

export type GarantieFinanciereIobspFormValues2026 = zod.infer<
  ReturnType<typeof createGarantieFinanciereIobspSchema2026>
>;
